import LaunchpadContext from "contexts/LaunchpadContext"
import { useContext } from "react"

const useLaunchpadContext = () => useContext(LaunchpadContext)

export default useLaunchpadContext
